import PropTypes from 'prop-types';
import React from 'react';
import FileDescriptor from '../FileDescriptor/FileDescriptor';
import FileInput from '../FileInput/FileInput';
import loadingImage from './loading.gif';
import './FileUpload.css';

var FileUpload = function FileUpload(_ref) {
  var file = _ref.file,
      isUploading = _ref.isUploading,
      fieldName = _ref.fieldName,
      onClick = _ref.onClick,
      _ref$input = _ref.input,
      input = _ref$input === void 0 ? {} : _ref$input,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onDelete = _ref.onDelete,
      buttonText = _ref.buttonText,
      buttonClassName = _ref.buttonClassName,
      disabled = _ref.disabled;

  if (file && file.name && file.size) {
    return React.createElement(FileDescriptor, {
      file: file,
      disabled: disabled,
      onClick: onClick,
      onDelete: onDelete
    });
  }

  if (isUploading) {
    return React.createElement('div', {
      className: 'FileUpload uploading'
    }, React.createElement('span', {
      className: 'FileUpload-uploading-text'
    }, 'Uploading...'), React.createElement('img', {
      src: loadingImage,
      width: 22,
      height: 22,
      alt: 'Uploading'
    }));
  }

  return React.createElement('div', {
    className: 'FileUpload'
  }, React.createElement(FileInput, {
    name: fieldName,
    onChange: onChange || input.onChange,
    onBlur: onBlur || input.onBlur,
    buttonText: buttonText,
    buttonClassName: buttonClassName,
    disabled: disabled
  }));
};

FileUpload.propTypes = {
  file: PropTypes.shape({
    name: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  isUploading: PropTypes.bool,
  fieldName: PropTypes.string,
  onDelete: PropTypes.func,
  buttonText: PropTypes.string,
  buttonClassName: PropTypes.string,
  disabled: PropTypes.bool
};
FileUpload.defaultProps = {
  isUploading: false,
  disabled: false
};
export default FileUpload;